import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { multiClientMiddleware } from 'redux-axios-middleware'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

import getEndpoints from './api'

import rootReducer from '@redux'
import { isClient, country, locale } from '@utils/common'
import { buildAuthorizationHeader } from '@utils/identity'
import Cookies from 'js-cookie'

const CAN_USE_DOM = typeof window !== 'undefined'

const analytics =
  CAN_USE_DOM && window.analytics ? window.analytics : undefined

const persistConfig = {
  storage,
  key: 'heima',
  whitelist: ['app']
}

const createStoreWithMiddleware = applyMiddleware(
  thunk.withExtraArgument({ locale, analytics }),
  multiClientMiddleware(getEndpoints({ locale }), {
    returnRejectedPromiseOnError: true,
    interceptors: {
      request: [
        (_, req) => {
          const country = Cookies.get('country')
          const isIdentity = req.baseURL.includes('identity')

          req.headers = {
            ...req.headers,
            ...buildAuthorizationHeader(),
            ...(!isIdentity && { Country: country })
          }

          return req
        }
      ]
    }
  })
)(createStore)

const rootReducers = combineReducers({
  ...rootReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducers)

const store = createStoreWithMiddleware(
  persistedReducer,
  compose(
    (process.env.APP_ENV !== 'production' ||
      process.env.ENABLE_REDUX_DEVTOOLS === 'true') &&
      isClient &&
      window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__({
        name: 'Heima',
        trace: true
      })
      : (f) => f
  )
)

store.__PERSISTOR = persistStore(store)

export default store
